export default __webpack_public_path__ + "static/media/BrainBreak cards64.f377ff3b.png";